export default {
  title: 'You can close this window(NL)',
  subTitle:
    ' We noticed you using Waitless in another browser window. You can close this window, or re-scan a QR code to visit again.(NL)',
  openCameraButton: 'open camera(NL)',
};
